/*
 * Copyright (c) 2025 curryfirm.com
 */

export const DEBUG = false;

// ROUTING STUFF
export const ROUTE_EXPIRATION_MILLISECONDS = 10 * 60 * 1000;    // Computed routes considered good for 10 minutes
export const PRECISION_OF_LOCATION_ID = 3;  // About 100 meters, as applied to a lat or lng.

// Wizard navigation-related constants.
export const START_LOCATION_STEP_LABEL = "Choose 1 Starting Location";
export const END_LOCATION_STEP_LABEL = "Choose 1 Final Destination";
export const FORWARD = "forward";
export const BACK = "back";
export const ROUTE_TYPES = Object.freeze({
    SWAP_AND_DROP: "swap-and-drop",
    TO_DUMP_AND_BACK: "to-dump-and-back",
})

export const LOCATION_CHOOSING_MODES = {
    current: 'current',
    dropLot: 'drop-lot',
    custom: 'custom',
};

export const GOOGLE_MAPS_KEY = "AIzaSyBLcCUv_vP2eJR-D8mo-jtEpebFKD7XI7I";
export const TRACKER_WORKBOOK_API_KEY = "AIzaSyCYmE-mxdE1NsEOdeATLdU6nT54bq61Fak";
export const TRACKER_WORKBOOK_ID = "1EYVkA6a2UAejhaeM18D4m32dSMNGFte_Z-hXXrTJJDE";
// This one's for testing:
// export const TRACKER_WORKBOOK_ID = "1SyW3GMrHsaDZulkkiO9fOJ3V1hy1NyFwQawhymZ8Nxs";
export const METERS_PER_MILE = 1609.344;
export const DROP_LOT_STREETS = [ "Fox Tail", "Harrow" ];
export const MAX_DUMPSTERS_TO_ROUTE = 7;
export const MOVES = Object.freeze({
    TO_DUMPSTER: 'to-dumpster',
    TO_DUMP: 'to-dump',
    TO_ENDING_POINT: 'to-ending-point',
});

// Worksheet range references in the Google Sheets doc from DumpsterTrack
export const DUMPSTER_INFO_RANGE = "DumpsterInfo!A:L";
export const UNIQUE_LOCATIONS_LOGGED_RANGE = "UniqueLocationsLogged!A:H";
export const DUMPS_RANGE = "Dumps!A:H";

// Column titles of DumpsterInfo worksheet, but order in not important
export const DUMPSTER_INFO_COLUMN_TITLES = {
    dumpsterSerial: "DumpsterSerial",
    dumpsterCapacity: "Dumpster Capacity",
    street: "Street",
    customer: "Customer",
    timestamp: "DropoffTimestamp",
    latitude: "LastLatitude",
    longitude: "LastLongitude",
    qrText: "TextToEncodeIntoQrCode",
    city: "City",
    state: "State",
    zip: "Zip",
    locationId: "locationId",
};

// Column titles of UniqueLocationsLogged worksheet, but order in sheet not important
export const UNIQUE_LOCATIONS_LOGGED_COLUMN_TITLES = {
    customer: 'customer',
    lat: 'lat',
    lng: 'lng',
    street: 'street',
    city: 'city',
    state: 'state',
    zip: 'zip',
    locationId: 'locationId',
};

// Column titles of Dumps worksheet, but order in sheet is unimportant.
export const DUMPS_COLUMN_TITLES = {
    name: 'name',
    lat: 'lat',
    lng: 'lng',
    street: 'street',
    city: 'city',
    state: 'state',
    zip: 'zip',
    locationId: 'locationId',
};

export const CAPACITIES = Object.freeze({
    ELEVEN: "11",
    FIFTEEN: "15",
    TWENTYONE: "21",
});

export const SWAPPABLE_CAN_TYPES = Object.freeze({
    ELEVENS: "elevens",
    FIFTEENS: "fifteens",
    TWENTYONES: "twenty-ones",
});

export const MEASUREMENT = {
    TIME: "time",
    DISTANCE: "distance",
};